import BaseModel from '../../base';
import EventTeam from '..';

export default class TeamHistory extends BaseModel {
  constructor(history = {}, url = 'team-histories') {
    super(history, url);

    Object.assign(this, history);

    this.team_id = history.team_id ?? null;
    this.user_id = history.user_id ?? null;
    this.created_at = history.created_at || null;
    this.team = history.team ? new EventTeam(history.team) : null;
  }
}
